import { writable } from "svelte/store";
import { featureEnabled } from "../features";
import { response } from "../global";

export const links = writable([]);

export const displayLinks = writable(false);

/**
 * Reset suggested questions to null and set
 * display to false
 */
export function resetLinks() {
  links.set([]);
  displayLinks.set(false);
}

response.subscribe((data = {}) => {
  resetLinks();

  if (data.payload && data.payload.features && featureEnabled("links")) {
    const linksFeature = data.payload.features.find(
      (feature) => feature.type === "links"
    );
    if (linksFeature && linksFeature.payload && linksFeature.payload.length) {
      links.set(linksFeature.payload);
    }
  }
});
